import { render, staticRenderFns } from "./scene_3.vue?vue&type=template&id=0afa72b6&"
import script from "./scene_3.vue?vue&type=script&lang=ts&"
export * from "./scene_3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports